import { apiBaseUrl } from 'APIs';
import axios, { AxiosRequestConfig } from 'axios';
import { ACCESS_TOKEN } from 'constant';
import { IUserPersonalData, UserData } from 'interfaces/UserData.interface';
import { uploadFileUtil } from 'utils/Fileupload.utils';

export interface IToggleSubscribeUserProps {
  fromUserId: number;
  toUserId: number;
  trialDuration?: Date;
}
export interface FollowUserData {
  followerId: number;
  followingId: number;
}

export const getInboxUsers = async () => {
  const config: AxiosRequestConfig<{}> = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
    },
  };
  const url = `${apiBaseUrl}users/`;
  return await axios.get(url, config);
};

export const postUserData = async (data: Partial<UserData>, origin: string) => {
  const url = `${apiBaseUrl}auth/signup/`;
  return await axios.post(url, { ...data, clientType: origin });
};

export const getOtherUserData = async (
  username: string,
  transactions?: boolean
) => {
  const config: AxiosRequestConfig<{}> = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
    },
  };
  const url = `${apiBaseUrl}users/${username}${
    transactions ? '?transactions=true' : '?transactions=false'
  }`;
  try {
    const res = await axios.get<UserData>(url, config);
    return res.data;
  } catch (error) {
    console.log('error', error);
  }
};

export const toggleSubscribeUser = async (data: IToggleSubscribeUserProps) => {
  const config: AxiosRequestConfig<{}> = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
    },
  };
  const url = `${apiBaseUrl}subscription/`;
  return await axios.post(url, data, config);
};

export const toggleUnSubscribeUser = async (id: number) => {
  const config: AxiosRequestConfig<{}> = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
    },
  };
  const url = `${apiBaseUrl}subscription/${id}`;
  return await axios.delete(url, config);
};

export const followUser = async (data: FollowUserData) => {
  const config: AxiosRequestConfig<{}> = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
    },
  };
  const url = `${apiBaseUrl}follow/follow/`;
  return await axios.post(url, data, config);
};

export const unfollowUser = async (data: FollowUserData) => {
  const config: AxiosRequestConfig<{}> = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
    },
  };
  const url = `${apiBaseUrl}follow/unfollow/`;
  return await axios.post(url, data, config);
};

export const addPersonalDetails = async (
  data: IUserPersonalData,
  userId: number,
  username: string,
  walletAddress: string
) => {
  const config: AxiosRequestConfig<{}> = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
    },
  };
  const { idPictures, ...otherDetails } = data;
  const uploadedImages = await Promise.all(
    idPictures.map(async file => await uploadFileUtil(file))
  );
  const url = `${apiBaseUrl}personal/`;
  return await axios.post(
    url,
    {
      ...otherDetails,
      userId,
      walletAddress,
      username,
      idPictures: uploadedImages,
    },
    config
  );
};

export const getInvites = async (username: string) => {
  const url = `${apiBaseUrl}users/invite-creators/${username}`;
  return await axios.get(url);
};

export const isValidToken = async (token: string) => {
  const url = `${apiBaseUrl}auth/verify-token`;
  return await axios.post(url, { token });
};

export const updateToken = async (token: string) => {
  const url = `${apiBaseUrl}auth-token`;

  return await axios.patch(url, { token });
};

export const searchedUsers = async (query: string) => {
  const url = `${apiBaseUrl}users/search/users?query=${query}`;
  return await axios.get(url);
};

export const getFeaturedUsers = async () => {
  const url = `${apiBaseUrl}users/find/featured-artists`;
  return await axios.get(url);
};

export const getBackstageToken = async (username: string) => {
  const url = `${apiBaseUrl}users/invite-backstage/${username}`;
  return await axios.get(url);
};

export const verifyBackstageToken = async (token: string, userId: number) => {
  const url = `${apiBaseUrl}users/invite-backstage/token/backstage/${token}?userId=${userId}`;
  return await axios.get(url);
};

export const getUserLikesAndViews = async (
  username: string
): Promise<{ likes: number; views: number }> => {
  const url = `${apiBaseUrl}users/likes-views/total/${username}`;
  const res = await axios.get(url);
  return res.data;
};
